export default "__VITE_ASSET__DebtVHYn__"